/* NEGT Leather theme scripts: no dependencies */
(function () {
  'use strict';

  var routes = window.routes || { cart_url: '/cart', cart_add_url: '/cart/add' };

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.getElementById('MobileMenu');
    if (!toggle || !menu) return;

    function open() {
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = menu.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    }
    toggle.addEventListener('click', open);
    menu.querySelectorAll('[data-menu-close]').forEach(function (btn) { btn.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) close();
    });
  }

  /* ---------- Desktop dropdowns: one open at a time ---------- */
  function initDropdowns() {
    var dropdowns = document.querySelectorAll('[data-dropdown]');
    if (!dropdowns.length) return;
    dropdowns.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        dropdowns.forEach(function (other) { if (other !== d) other.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      dropdowns.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      dropdowns.forEach(function (d) {
        if (d.open) { d.open = false; d.querySelector('summary').focus(); }
      });
    });
  }

  /* ---------- Cart count + toast ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  function refreshCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }
  var toastTimer;
  function showToast(message) {
    var toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.innerHTML = '';
    var text = document.createElement('span');
    text.textContent = message;
    var link = document.createElement('a');
    link.href = routes.cart_url;
    link.textContent = 'View cart';
    toast.appendChild(text);
    toast.appendChild(link);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 5000);
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var prices = {};
    var pricesEl = root.querySelector('[data-variant-prices]');
    if (pricesEl) { try { prices = JSON.parse(pricesEl.textContent); } catch (e) { prices = {}; } }

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var select = root.querySelector('[data-variant-select]');
    var addBtn = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var priceEl = root.querySelector('[data-price]');
    var errorEl = root.querySelector('[data-form-error]');
    var fieldsets = root.querySelectorAll('[data-option]');
    var current = product.variants.find(function (v) { return String(v.id) === String(select && select.value); }) || product.variants[0];

    function selectedOptions() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function markAvailability() {
      // Grey out values that have no available variant with the other current selections
      var selected = selectedOptions();
      fieldsets.forEach(function (fs, index) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = selected.slice();
          test[index] = input.value;
          var match = product.variants.find(function (v) {
            return v.options.every(function (o, i) { return test[i] === null || o === test[i]; });
          });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function render(variant) {
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-option-selected]');
        if (out && checked) out.textContent = checked.value;
      });

      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      current = variant;
      if (select) select.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      document.querySelectorAll('[data-sticky-add]').forEach(function (b) { b.disabled = !variant.available; b.textContent = variant.available ? 'Add to cart' : 'Sold out'; });

      var p = prices[variant.id];
      if (p && priceEl) {
        var html = '<span class="price"><span class="price__current">' + p.price + '</span>';
        if (p.compare) html += '<s class="price__compare"><span class="visually-hidden">Regular price</span>' + p.compare + '</s>';
        priceEl.innerHTML = html + '</span>';
        document.querySelectorAll('[data-sticky-price]').forEach(function (sp) { sp.textContent = p.price; });
        document.dispatchEvent(new CustomEvent('negt:price:changed', { detail: { el: priceEl } }));
      }

      var colourEl = root.querySelector('[data-spec-colour]');
      if (colourEl) {
        product.options.forEach(function (name, i) {
          var n = String(name).toLowerCase();
          if (n === 'color' || n === 'colour') colourEl.textContent = variant.options[i];
        });
      }

      if (variant.featured_media) goToMedia(String(variant.featured_media.id));

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      markAvailability();
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () {
        var selected = selectedOptions();
        var variant = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        render(variant);
      });
    });
    if (select) select.addEventListener('change', function () {
      var v = product.variants.find(function (x) { return String(x.id) === select.value; });
      if (v) render(v);
    });
    markAvailability();

    /* Quantity */
    var qtyInput = root.querySelector('[data-qty-input]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    }

    /* Add to cart without leaving the page */
    if (form && window.fetch && window.FormData) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.name !== 'add') return;
        e.preventDefault();
        errorEl.hidden = true;
        addBtn.classList.add('is-loading');
        addBtn.disabled = true;
        fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'This item could not be added to your cart.');
            return refreshCart().then(function (cart) {
              addBtn.classList.add('is-added');
              setTimeout(function () { addBtn.classList.remove('is-added'); }, 1400);
              document.dispatchEvent(new CustomEvent('negt:cart:added', { detail: res.data }));
              if (window.NEGT && window.NEGT.openCart) window.NEGT.openCart(cart);
              else showToast((res.data.product_title || 'Item') + ' added to your cart');
            });
          })
          .catch(function (err) {
            errorEl.textContent = err.message;
            errorEl.hidden = false;
          })
          .finally(function () {
            addBtn.classList.remove('is-loading');
            addBtn.disabled = !(current && current.available);
          });
      });
    }

    /* Gallery */
    var viewport = root.querySelector('[data-gallery-viewport]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    function setCurrentThumb(id) {
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') === id ? 'true' : 'false'); });
    }
    function goToMedia(id) {
      if (!viewport) return;
      var slide = viewport.querySelector('[data-media-id="' + id + '"]');
      if (!slide) return;
      viewport.scrollTo({ left: slide.offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
      setCurrentThumb(id);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goToMedia(t.getAttribute('data-thumb')); });
    });
    if (viewport && thumbs.length) {
      var ticking = false;
      viewport.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
          var slide = viewport.children[index];
          if (slide) setCurrentThumb(slide.getAttribute('data-media-id'));
          ticking = false;
        });
      }, { passive: true });
    }
  }

  window.NEGT = window.NEGT || {};
  window.NEGT.initProduct = initProduct;

  /* ---------- Product recommendations ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
        else el.remove();
        document.dispatchEvent(new CustomEvent('negt:content:loaded', { detail: { el: el } }));
      })
      .catch(function () { el.remove(); });
  }

  /* ---------- Collection sort (no-JS fallback is the form) ---------- */
  function initSort() {
    if (document.querySelector('[data-results]')) return;
    document.querySelectorAll('[data-sort-select]').forEach(function (s) {
      s.addEventListener('change', function () { s.form.submit(); });
    });
  }

  /* ---------- Cart page ---------- */
  function initCartPage() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;
    var updateBtn = form.querySelector('[data-cart-update]');
    var timer;
    form.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (form.requestSubmit && updateBtn) form.requestSubmit(updateBtn);
          else if (updateBtn) updateBtn.click();
        }, 400);
      });
    });
  }

  /* ---------- Address country defaults ---------- */
  function initCountrySelects() {
    document.querySelectorAll('select[data-default]').forEach(function (s) {
      var value = s.getAttribute('data-default');
      if (value) s.value = value;
    });
  }

  function init() {
    initMenu();
    initDropdowns();
    document.querySelectorAll('[data-product]').forEach(initProduct);
    document.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    initSort();
    initCartPage();
    initCountrySelects();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* ==========================================================================
     NEGT additions: cart drawer, filters drawer, sliders, tabs, sticky add to
     cart, size guide + quick view modals, scroll-to-top. Functional only; the
     transitions live in negt-motion.css.
     ========================================================================== */
  var NEGT = window.NEGT;
  function money(cents) {
    var fmt = window.NEGT_MONEY || '${{amount}}';
    var v = (cents / 100);
    var withDec = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.toFixed(2).replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, withDec);
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }

  var lastFocus = null;
  function openDrawer(d) {
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer');
    var f = d.querySelector('[data-drawer-close]:not(.drawer__backdrop)'); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer.is-open')) document.body.classList.remove('has-drawer');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-drawer-close]');
    if (c) closeDrawer(c.closest('.drawer'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  });

  /* Cart drawer */
  var cartDrawer = document.getElementById('CartDrawer');
  function renderCart(cart) {
    if (!cartDrawer) return;
    var body = cartDrawer.querySelector('[data-cart-body]');
    var total = cartDrawer.querySelector('[data-cart-total]');
    var foot = cartDrawer.querySelector('[data-cart-foot]');
    if (!cart.item_count) {
      body.innerHTML = '<p class="drawer__empty">Your cart is empty.</p>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img class="mini-item__img" src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="72" height="90" loading="lazy">' : '<span class="mini-item__img"></span>';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="mini-item__variant">' + esc(it.variant_title) + '</p>' : '';
      return '<div class="mini-item">' + img + '<div><a class="mini-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<p class="mini-item__qty">Qty ' + it.quantity + '</p><button type="button" class="mini-item__remove" data-remove-key="' + esc(it.key) + '">Remove</button></div>' +
        '<p class="mini-item__price">' + money(it.final_line_price) + '</p></div>';
    }).join('');
    total.textContent = money(cart.total_price);
  }
  NEGT.openCart = cartDrawer ? function (cart) {
    var p = cart ? Promise.resolve(cart) : refreshCart();
    p.then(function (c) { renderCart(c); openDrawer(cartDrawer); });
  } : null;
  if (cartDrawer) {
    document.querySelectorAll('.cart-link').forEach(function (l) {
      l.addEventListener('click', function (e) { e.preventDefault(); NEGT.openCart(); });
    });
    cartDrawer.addEventListener('click', function (e) {
      var r = e.target.closest('[data-remove-key]');
      if (!r) return;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: r.getAttribute('data-remove-key'), quantity: 0 }) })
        .then(function (res) { return res.json(); })
        .then(function (cart) { updateCartCount(cart.item_count); renderCart(cart); });
    });
  }

  /* Filters drawer + live results */
  function initFilters() {
    var drawer = document.getElementById('FilterDrawer');
    document.querySelectorAll('[data-filter-open]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(drawer); }); });
    document.addEventListener('click', function (e) { var b = e.target.closest('[data-filter-open]'); if (b && !b.dataset.bound) { openDrawer(drawer); } });
    var form = document.querySelector('[data-filter-form]');
    var results = document.querySelector('[data-results]');
    if (!results || !window.fetch) return;
    var timer;
    function load(url) {
      results.classList.add('is-loading');
      var u = new URL(url, location.href);
      u.searchParams.set('section_id', results.getAttribute('data-section-id'));
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-results]');
        if (fresh) results.innerHTML = fresh.innerHTML;
        results.classList.remove('is-loading');
        u.searchParams.delete('section_id');
        history.replaceState({}, '', u.toString());
        document.querySelectorAll('[data-filter-open]').forEach(function (b) { b.dataset.bound = ''; });
        document.dispatchEvent(new CustomEvent('negt:results:swapped', { detail: { el: results } }));
      }).catch(function () { location.href = url; });
    }
    if (form) {
      form.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var params = new URLSearchParams(new FormData(form));
          Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
          load(location.pathname + '?' + params.toString());
        }, 300);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); closeDrawer(drawer); });
    }
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-sort-select]')) return;
      var params = new URLSearchParams(location.search);
      params.set('sort_by', e.target.value);
      load(location.pathname + '?' + params.toString());
    });
    document.querySelectorAll('[data-filter-open]').forEach(function (b) { b.dataset.bound = '1'; });
  }

  /* Slider: arrows + drag to scroll */
  function initSliders(scope) {
    (scope || document).querySelectorAll('[data-slider]').forEach(function (s) {
      if (s.dataset.ready) return; s.dataset.ready = '1';
      var track = s.querySelector('.slider__track');
      if (!track) return;
      var prev = s.querySelector('[data-slide-prev]'); var next = s.querySelector('[data-slide-next]');
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); }
        track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return; down = false;
        if (moved) {
          var w = step(); var target = Math.round(track.scrollLeft / w) * w;
          track.classList.remove('is-dragging');
          track.scrollTo({ left: target, behavior: 'smooth' });
        }
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* Tabs (leather types) */
  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-tabs]').forEach(function (t) {
      var tabs = t.querySelectorAll('[role="tab"]');
      var panels = t.querySelectorAll('[role="tabpanel"]');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (x, j) { x.setAttribute('aria-selected', j === i ? 'true' : 'false'); x.tabIndex = j === i ? 0 : -1; });
          panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); p.setAttribute('aria-hidden', j === i ? 'false' : 'true'); });
        });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[n].click(); tabs[n].focus();
        });
      });
    });
  }

  /* Sticky add to cart */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var main = document.querySelector('[data-add-button]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.footer');
    var mainVisible = true, footerVisible = false;
    function update() { var show = !mainVisible && !footerVisible; bar.classList.toggle('is-visible', show); document.body.classList.toggle('has-sticky-atc', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true'); }
    new IntersectionObserver(function (en) { mainVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0; update(); }).observe(main);
    if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; update(); }).observe(footer);
    var btn = bar.querySelector('[data-sticky-add]');
    if (btn) btn.addEventListener('click', function () { main.click(); });
  }

  /* Modals: size guide, quick view, lightbox */
  function openModal(m) { if (m && m.showModal) m.showModal(); else if (m) m.setAttribute('open', ''); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-modal-open]');
    if (o) { e.preventDefault(); openModal(document.getElementById(o.getAttribute('data-modal-open'))); return; }
    var c = e.target.closest('[data-modal-close]');
    if (c) { var m = c.closest('dialog'); if (m) m.close(); return; }
    if (e.target.tagName === 'DIALOG') { e.target.close(); return; }
    var q = e.target.closest('[data-quick-view]');
    if (q) {
      e.preventDefault();
      var href = q.getAttribute('data-quick-view');
      var modal = document.getElementById('QuickView');
      if (!modal) { location.href = href; return; }
      var box = modal.querySelector('[data-quick-body]');
      box.innerHTML = '<p class="drawer__empty">Loading…</p>';
      openModal(modal);
      fetch(href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=main')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.querySelector('[data-product]');
          if (!sec) { location.href = href; return; }
          sec.querySelectorAll('.product__accordions, [data-sticky-atc], dialog').forEach(function (n) { n.remove(); });
          box.innerHTML = ''; box.appendChild(sec);
          initProduct(sec);
          document.dispatchEvent(new CustomEvent('negt:content:loaded', { detail: { el: sec } }));
        })
        .catch(function () { location.href = href; });
      return;
    }
    var z = e.target.closest('[data-lightbox] img');
    if (z && window.matchMedia('(max-width: 989px)').matches) {
      var lb = document.getElementById('Lightbox');
      if (!lb) return;
      var img = lb.querySelector('img');
      img.src = z.currentSrc || z.src; img.alt = z.alt;
      openModal(lb);
    }
  });

  /* Scroll to top */
  function initToTop() {
    var b = document.querySelector('[data-to-top]');
    if (!b) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { b.classList.toggle('is-visible', window.scrollY > 600); ticking = false; });
    }, { passive: true });
    b.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function initNegt() { initFilters(); initSliders(); initTabs(); initStickyAtc(); initToTop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initNegt);
  else initNegt();

  /* Theme editor: re-run when sections are added or reloaded */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    t.querySelectorAll('[data-product]').forEach(initProduct);
    t.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    if (t.querySelector('[data-menu-toggle]')) initMenu();
    initSliders(t); initTabs(t);
  });
})();
